// 类型定义
export interface PaperItem {
  work_id: string
  title: string
  created_at: string
  updated_at: string
  type: string | number
  payment_state: '已支付' | '未支付'
}

// 定义枚举：type 数字值
export enum DocType {
  Proposal = 1, // 开题报告
  Review, // 文献综述
  Thesis, // 毕业论文
  Course, // 课程论文
  Presentation, // 答辩PPT
  Reduce, // 降重
  AIGC, // 降AIGC
  Format // 格式排版
}

// type -> 中文 label 的映射
export const DocTypeLabelMap: Record<any, string> = {
  [DocType.Proposal]: '开题报告',
  [DocType.Review]: '文献综述',
  [DocType.Thesis]: '毕业论文',
  [DocType.Course]: '课程论文',
  [DocType.Presentation]: '答辩PPT',
  [DocType.Reduce]: '降重',
  [DocType.AIGC]: '降AIGC',
  [DocType.Format]: '格式排版'
}

// type -> 英文 value 的映射
export const DocTypeValueMap: Record<DocType, string> = {
  [DocType.Proposal]: 'proposal',
  [DocType.Review]: 'review',
  [DocType.Thesis]: 'thesis',
  [DocType.Course]: 'course',
  [DocType.Presentation]: 'presentation',
  [DocType.Reduce]: 'reduce',
  [DocType.AIGC]: 'aigc',
  [DocType.Format]: 'format'
}

// 统一的 TYPE_LIST
export const TYPE_LIST = [
  { label: '全部', value: 'all', type: 0 },
  ...Object.values(DocType)
    .filter((t): t is DocType => typeof t === 'number')
    .map(type => ({
      label: DocTypeLabelMap[type],
      value: DocTypeValueMap[type],
      type
    }))
] as const

export const TABS = [
  { label: '已支付', type: 'paid' },
  { label: '未支付', type: 'unpaid' }
] as const
